import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Country } from '../types';
import './CountrySelectionModal.scss';

interface CountrySelectionModalProps {
  show: boolean;
  countries: Country[];
  onSelect: (countryCode: string) => void;
}

const CountrySelectionModal: React.FC<CountrySelectionModalProps> = ({
  show,
  countries,
  onSelect
}) => {
  const handleCountrySelect = (countryCode: string) => {
    onSelect(countryCode);
  };

  return (
    <Modal 
      show={show} 
      onHide={() => {}} // Prevent closing without selection
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      className="country-selection-modal"
    >
      <Modal.Header className="modal-header">
        <Modal.Title className="text-white">
          <i className="fas fa-globe me-2"></i>
          Select Your Country
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="modal-body">
        <p className="text-center mb-4 text-muted">
          Please select your country to continue. This helps us show you relevant events and pricing.
        </p>
        <div className="country-list">
          {countries.map((country) => (
            <div
              key={country.id}
              className="country-item"
              onClick={() => handleCountrySelect(country.code)}
            >
              <div className="d-flex align-items-center">
                <span className={`fi fi-${(country.code || '').toLowerCase()} me-3 country-flag`}></span>
                <div className="flex-grow-1">
                  <div className="country-name">{country.name}</div>
                  <div className="country-code-text">{country.code}</div>
                </div>
                <i className="fas fa-chevron-right text-muted"></i>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CountrySelectionModal;

